import { useCodeReferenceBlockSection } from "utilities/hooks/domain/block-configurations/use-code-reference-block-section";
import { EditablePageBlock } from "../page-block-list/editable-page-block";
import React from "react";
import { PageBlockProps } from "../page-block-list/page-block";
import { AdditionalCodeReferenceBlockData } from "models/interfaces/additional-block-data/additional-code-reference-block-data";
import CodeReferenceBlockEnhancedContentContextProvider from "utilities/contexts/notebooks/use-code-reference-block-enhanced-content-context";

interface CodeReferenceBlockProps extends PageBlockProps {}

export const CodeReferenceBlock = (
    props: CodeReferenceBlockProps
): JSX.Element => {
    const { section } = useCodeReferenceBlockSection(props.block);
    const additionalBlockData: AdditionalCodeReferenceBlockData = {
        section: section,
    };

    return (
        <CodeReferenceBlockEnhancedContentContextProvider>
            <EditablePageBlock
                {...props}
                additionalBlockData={additionalBlockData}
            />
        </CodeReferenceBlockEnhancedContentContextProvider>
    );
};
